import { put, call } from "redux-saga/effects";
import { arrayToEntityMap } from "lib/data";

import { sendSchoolMoneyDataRequest } from "state/fetchSagas";
import { getSchoolMoneyLocalStoreData, saveSchoolMoneyLocalStoreData } from "state/localStore";
import { fetchSchoolsSucceeded } from "state/school_money/actions";

import School from "state/school_money/entities/School";

export default function* fetchSchoolsSaga(action) {
  const forceApiRefresh = action.payload.forceApiRefresh;
  let schoolsData;

  if(!forceApiRefresh){
    schoolsData = getSchoolMoneyLocalStoreData("school");
  }

  if(schoolsData === undefined) {
    const response = yield call(sendSchoolMoneyDataRequest, "get_schools");
    schoolsData = response.data.schools;
    saveSchoolMoneyLocalStoreData("school", schoolsData);
  }

  const schoolsByID = arrayToEntityMap(School.fromAppserver, school => school.id, schoolsData);
  yield put(fetchSchoolsSucceeded(schoolsByID));

}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/fetchSchoolsSaga.js